// extracted by mini-css-extract-plugin
module.exports = {"about":"HomeAbout_about__1A641"};